<h2>{{ 'register.manualFlow.modals.editEducation' | translate }}</h2>

<form [formGroup]="educationForm" class="field-grid">
    <div class="field">
        <label for="editDegree">{{ 'register.manualFlow.step3.degree' | translate }}</label>
        <input class="otherInput" id="editDegree" formControlName="degree" [placeholder]="'register.step3.degree.placeholder' | translate">
        <p class="error-message" *ngIf="educationForm.get('degree')?.invalid && educationForm.get('degree')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="editInstitution">{{ 'register.manualFlow.step3.institution' | translate }}</label>
        <input class="otherInput" id="editInstitution" type="text" formControlName="institution" [placeholder]="'register.step3.institution.placeholder' | translate">
        <p class="error-message" *ngIf="educationForm.get('institution')?.invalid && educationForm.get('institution')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="editEduStart">{{ 'register.manualFlow.step3.start' | translate }}</label>
        <input class="otherInput" id="editEduStart" type="date" formControlName="startDate">
        <p class="error-message" *ngIf="educationForm.get('startDate')?.invalid && educationForm.get('startDate')?.touched">{{ 'register.manualFlow.errors.date' | translate }}</p>
    </div>
    <div class="field">
        <label for="editEduEnd">{{ 'register.manualFlow.step3.end' | translate }}</label>
        <input class="otherInput" id="editEduEnd" type="date" formControlName="endDate" [min]="educationForm.get('startDate')?.value" [class.field-error]="educationForm.hasError('endBeforeStart')">
        <p class="field-hint">{{ 'register.manualFlow.step3.endHelp' | translate }}</p>
        <p class="error-message" *ngIf="educationForm.hasError('endBeforeStart')">{{ 'register.manualFlow.errors.endBeforeStart' | translate }}</p>
    </div>
</form>

<div class="modal-actions">
    <button type="button" class="text-button" (click)="close()">{{ 'register.manualFlow.modals.cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="saveEditEducation()">{{ 'register.manualFlow.modals.save' | translate }}</button>
</div>
